import { createAction } from '@reduxjs/toolkit';
import React from 'react';
import { Styles } from 'react-modal';
import type { AppThunk } from '../store/configureStore';

export type AlertModalOptions = {
  body?: string | React.ReactNode;
  useConfirm?: boolean;
  useCancel?: boolean;
  styles?: Styles;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: string;
  cancelColor?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  shouldCloseOnOverlayClick?: boolean;
};

export const OPEN_ALERT_MODAL = createAction<AlertModalOptions>('OPEN_ALERT_MODAL');
export const CLOSE_ALERT_MODAL = createAction<AlertModalOptions>('CLOSE_ALERT_MODAL');

export const openAlertModal =
  (options: AlertModalOptions): AppThunk =>
  (dispatch) =>
    dispatch(OPEN_ALERT_MODAL(options));

export const closeAlertModal =
  (options: AlertModalOptions): AppThunk =>
  (dispatch) =>
    dispatch(CLOSE_ALERT_MODAL(options));
